import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-form-debug',
  templateUrl: './form-debug.component.html',
  styleUrls: ['./form-debug.component.scss']
})
export class FormDebugComponent implements OnInit {

  @Input() form;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/shared/form-debug/form-debug.component.ts